// extracted by mini-css-extract-plugin
export var videoContainer = "styles-module--videoContainer--ysJ7d";
export var playButton = "styles-module--playButton---IjCA";
export var youtubeFrame = "styles-module--youtubeFrame--TGVuX";
export var thumbnailContainer = "styles-module--thumbnailContainer--mRe7+";